const getContainer = () => {
  let container = document.getElementById("app-message-root");
  if (!container) {
    container = document.createElement("div");
    container.id = "app-message-root";
    document.body.appendChild(container);
  }
  return container;
};

const show = (type, text, duration = 2000) => {
  const container = getContainer();
  const item = document.createElement("div");
  item.className = `message message--${type}`;
  item.textContent = text;
  container.appendChild(item);
  requestAnimationFrame(() => {
    item.classList.add("message--show");
  });
  window.setTimeout(() => {
    item.classList.remove("message--show");
    item.classList.add("message--hide");
    window.setTimeout(() => {
      item.remove();
    }, 200);
  }, duration);
};

const message = {
  toast: (text, duration) => show("toast", text, duration),
  success: (text, duration) => show("success", text, duration),
};

export default message;
